import {Injectable} from '@angular/core';
import {Perfil} from 'src/app/interface/perfil';
import {BaseClientService} from './base-client.service';

@Injectable({
  providedIn: 'root'
})
export class AcessoService {

  constructor(private client: BaseClientService) {
  }

  async getPerfil(): Promise<Perfil[]> {
    return this.client.get(`/acesso/sistema/CMD-COLETA/perfil`).toPromise();
  }

  async getEstabelecimentos(): Promise<any> {
    return this.client.get(`/acesso/sistema/CMD-COLETA/perfil`).toPromise();
  }

  async getFuncionalidade(siglaPerfil): Promise<any> {
    return this.client.get(`/acesso/sistema/CMD-COLETA/perfil/${siglaPerfil}/funcionalidade`).toPromise();
  }

  async getPermissoes(siglaPerfil): Promise<any> {
    return this.client.get(`/permissao/sistema/CMD-COLETA/perfil/${siglaPerfil}`).toPromise();
  }

  async revoke(): Promise<any> {
    return this.client.get(`/oauth/revoke-token/`).toPromise();
  }

  async logout(): Promise<any> {
    return this.client.get(`/logout`).toPromise();
  }
  async logoutSso(): Promise<any> {
    return this.client.get(`/logout-sso`).toPromise();
  }
}
